// Copyright (c) 2022 by Move Closer

import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'

import { AllowedColor, ModuleBase, ModuleFactory } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'
import { HeadingModule, HeadingModuleContent } from './Heading.contracts'

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl
 */
export const headingContentFactory = (): HeadingModuleContent => ({
  align: undefined,
  alignDesktop: undefined,
  color: AllowedColor.Body,
  level: 1,
  text: '',
  decorator: ''
})

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl
 */
export const headingFactory: ModuleFactory<HeadingModule> = {
  ...abstractModuleFactory,
  createModule (): ModuleBase<HeadingModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: headingContentFactory(),
      driver: AvailableModuleDriver.Heading
    }
  }
}
